import { GET_VERIFICATION_CODE_ROUTE } from "@api-routes/eirSalesFacade";

export interface IVerificationCodeApi {
    operatorName: string;
}

export const getVerificationCode = (
    phoneNumber: string,
    setErrorMessage: (errorMessage: string) => void
): Promise<IVerificationCodeApi | undefined> =>
    fetch(GET_VERIFICATION_CODE_ROUTE, {
        body: JSON.stringify({ msisdn: phoneNumber }),
        headers: { "Content-Type": "application/json" },
        method: "POST",
    })
        .then((response) => response.json())
        .then((result: { errorMessage?: string; operatorName: string }) => {
            if (result?.errorMessage) {
                setErrorMessage(result.errorMessage);

                return undefined;
            }

            return result;
        });
